import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import AuthPage from "@/pages/AuthPage";
import Landing from "@/pages/Landing";
import ResetPassword from "@/pages/ResetPassword";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Install from "@/pages/Install";
import VolunteerApp from "@/pages/VolunteerApp";
import AdminApp from "@/pages/AdminApp";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-sand">
      <p className="text-muted-foreground">Loading…</p>
    </div>
  );
}

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/app"} replace />;
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/app"} replace />;
  return <Landing />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/install" element={<Install />} />
          <Route path="/app" element={<Protected><VolunteerApp /></Protected>} />
          <Route path="/admin" element={<Protected role="admin"><AdminApp /></Protected>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
